<template>
  <div class="container">
    <div class="content-wrapper">
      <div class="tab-container">
        <div
          class="tab-item overview-tab"
          :class="{ active: activeTab === 'overview' }"
          @click="setActiveTab('overview')"
        >
        </div>
        <div
          class="tab-item report-tab"
          :class="{ active: activeTab === 'report' }"
          @click="setActiveTab('report')"
        >
        </div>
      </div>
      <div class="tab-panel tab-panel_overview" v-show="activeTab === 'overview'">
        <img src="@/assets/images/kdSimulator/kdSimulator_1.jpg" alt="" style="width: 100%">
        <div class="banner_box">
          <van-swipe indicator-color="#FFFFFF" autoplay="2000" class="banner" v-if="imageList.length">
            <van-swipe-item v-for="image in imageList" :key="image.id"
                            v-track="{ functionName: '模拟器下载页banner-' + image.title }" @click="handleClick(image)">
              <img :src="getImage(image)"/>
            </van-swipe-item>
          </van-swipe>
        </div>
        <img src="@/assets/images/kdSimulator/kdSimulator_2.jpg" alt="" style="width: 100%;">
        <!--      <div class="apply-container">-->
        <!--        <img src="@/assets/images/kdSimulator/kdSimulator_3.png" alt="" style="width: 100%;">-->
        <!--        <div class="apply-entry-container">-->
        <!--          <div class="apply-text" :style="{ color: !status ? '#D2AB68' : '#9C9C9C' }">-->
        <!--            <div class="text">如果您对手柄使用感兴趣，欢迎点击提交申请意向，加入心愿清单</div>-->
        <!--          </div>-->
        <!--          <div-->
        <!--            class="apply-entry"-->
        <!--            :style="{ background: 'linear-gradient(180deg, #FFC987 0%, #FE0000 100%)' }"-->
        <!--            @click="openTips"-->
        <!--            v-track="{ functionName: '模拟器手柄申请-我感兴趣' }"-->
        <!--            v-show="status == false"-->
        <!--          >-->
        <!--            我感兴趣-->
        <!--          </div>-->
        <!--          <div-->
        <!--            class="apply-entry"-->
        <!--            :style="{ background: '#C4C4C4' }"-->
        <!--            v-show="status == true"-->
        <!--          >-->
        <!--            已申请-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <img src="@/assets/images/kdSimulator/kdSimulator_3.jpg" alt="" style="width: 100%;">
        <img src="@/assets/images/kdSimulator/kdSimulator_4.jpg" alt="" style="width: 100%;" @click="toCourses"
             v-track="{ functionName: '点我了解更多模拟器课程' }">
        <img src="@/assets/images/kdSimulator/kdSimulator_5.jpg" alt="" style="width: 100%;">
      </div>
      <div class="tab-panel practice-report" v-show="activeTab === 'report'">
        <div class="aifv-cons">
          <div class="aifv-top1">
            <div class="top-txt">PVI分区诊断</div>
            <div class="canvas-div">
              <canvas ref="practiceCanvas" class="canvas"></canvas>
              <div class="canvas-txt-info">
                <div class="info-flex info-top">
                  <div class="txt-info txt1">superior</div>
                  <div class="txt-info txt1">superior</div>
                </div>
                <div class="info-flex info-midd">
                  <div class="txt-info txt2">anterior</div>
                  <div class="txt-info txt2">posterior</div>
                  <div class="txt-info txt2">anterior</div>
                </div>
                <div class="info-flex info-bottom">
                  <div class="txt-info txt1">inferior</div>
                  <div class="txt-info txt1">inferior</div>
                </div>
              </div>
              <div class="canvas-con canvas-con-left">
                <div class="arc-txt arc1">RSPV</div>
                <div class="arc-txt arc2">RIPV</div>
              </div>
              <div class="canvas-con canvas-con-right">
                <div class="arc-txt arc1">LSPV</div>
                <div class="arc-txt arc2">LIPV</div>
              </div>
            </div>
            <div class="canvas-btm">
              <div class="btm-txt">
                <div class="label-block label-block3"></div>
                <span class="label-txt">无问题</span>
              </div>
              <div class="btm-txt">
                <div class="label-block label-block2"></div>
                <span class="label-txt">操作时间较长(>10min)</span>
              </div>
              <div class="btm-txt">
                <div class="label-block label-block4"></div>
                <span class="label-txt">连续性问题(有6mm以上Gap)</span>
              </div>
              <div class="btm-txt">
                <div class="label-block label-block1"></div>
                <span class="label-txt">单点稳定性问题(碎点&堆叠点>30%和FOT（4g,30%）不达标点>30%）</span>
              </div>
            </div>
          </div>
          <div class="aifv-top2">
            <div class="top-txt">模拟器报告分析</div>
            <RadarChart v-if="activeTab === 'report'" :activeTxt="'30'" :initData="aifvData" :titlePosition="'0'"
                        :isNationwide="true" width="100%">
            </RadarChart>
          </div>
          <div class="aifv-top3">
            <div class="top-txt">模拟器手术报告</div>
            <div v-if="aifvFileData" class="list-table">
              <div class="table-tr th">
                <div class="table-th table-td table-one">季度</div>
                <div class="table-th table-td table-two">日期</div>
                <div class="table-th table-td table-three">类型</div>
                <div class="table-th table-td table-four">AIFV</div>
              </div>
              <template v-if="aifvFileData.length > 0">
                <div class="div-list-block">
                  <div v-for="(item, index) in aifvFileData" :key="index" class="table-tr tr">
                    <div class="table-td table-one">{{ item.quarter }}</div>
                    <div class="table-td table-two">{{ item.operationTime }}</div>
                    <div class="table-td table-three">{{ item.operationType }}</div>
                    <div class="table-td table-four" style="cursor: pointer;" @click="handleJumpPDF(item)">
                      {{ item.operationScore }} >>
                    </div>
                  </div>
                </div>
              </template>
              <div class="empty-block" v-else-if="isNone">
                <img src="@/assets/images/zone/img18.png" class="empty-img" alt=""/>
                <div class="empty-txt">暂无内容</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showTips"
      class="tips-overlay"
      @touchmove.prevent
    >
      <div class="tips-dialog">
        <div class="header">
          <div class="dialog-close" @click="closeTips"></div>
          <div class="dialog-title">温馨提示</div>
        </div>

        <div class="dialog-content">
          <div class="dialog-item">
            <div class="dialog-item-label">申请理由:</div>
            <van-form @submit="applyForController">
              <van-field
                v-model.trim="applyReason"
                rows="2"
                :autosize="{ maxHeight: 96, minHeight: 96 }"
                type="textarea"
                maxlength="100"
                placeholder="请输入申请理由"
              />
              <div>
                <div class="tips">目前手柄申请火热，我们会基于您当前的iEP积分及提交申请顺序进行发放，感谢您的支持与理解。
                </div>
                <button v-track="{ functionName: '模拟器手柄申请' }" class="dialog-confirm" type="submit">
                  确认提交
                </button>
              </div>
            </van-form>
          </div>
        </div>
      </div>
    </div>
    <custom-dialog
      :visible.sync="cDialog.visible"
      @cancel="cDialog.cancel"
      @confirm="cDialog.confirm"
      @close="cDialog.close"
      v-bind="cDialog"
    >
      <div class="txts">{{ cDialog && cDialog.content }}</div>
    </custom-dialog>
    <img src="@/assets/images/aifv/img09.png" class="feedback" @click="isFeedBack = true" alt="">
    <van-overlay :show="isFeedBack" @click="handleCancelFeedback">
      <div class="wrap" @click.stop>
        <div class="wrap-txt">意见反馈</div>
        <div class="wrap-con">
          <van-field v-model="feedModel" autosize type="textarea" maxlength="200" placeholder="请描述您的问题~"
                     show-word-limit/>
        </div>
        <div class="warp-btn">
          <div class="btn btn1" @click="handleCancelFeedback">取消</div>
          <div class="btn btn2" @click="handleFeedBack()">提交反馈</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import CustomDialog from '@/views/cartoJourney/components/CustomDialog.vue'
import RadarChart from './components/RadarChart.vue'
import HomeBanner from '@/views/home/components/HomeBanner.vue'
import {trackPageView, timeoutPolling} from '@/utils/trace'
import {getShareInfo} from '../../utils/wxShare'
import {getRemindBool, postRemind} from '../../api/simulator'
import {getUserIdentity, debounce, setSha, traceClickURL} from '../../utils/util'
import {getSimulatorOnePage, getAIFVFileList} from '@/api/aifv'
import {updateIsRead, sendFeedback} from '@/api/api'
import {Toast} from 'vant'
import qs from 'qs'
import {isScorm} from '../../api/scorm'
import {getLibrayBannerByModuleApi} from '../../api/technology'

export default {
  components: {
    CustomDialog,
    RadarChart,
    HomeBanner
  },
  data() {
    return {
      cDialog: {
        visible: false,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        content: '',
        cancel: () => {
          this.cDialog.visible = false
        },
        confirm: () => {
          this.cDialog.visible = false
        },
        close: () => {
          this.cDialog.visible = false
        }
      },
      showTips: false,
      status: undefined,
      bodyStyleCache: {
        overflow: '',
        touchAction: ''
      },
      userIdentity: getUserIdentity(),
      applyReason: '',
      activeTab: 'overview',
      aifvAllData: {
        rpv_ant: undefined,
        rpv_rf: undefined,
        rpv_pst: undefined,
        rpv_inf: undefined,
        lpv_pst: undefined,
        lpv_rf: undefined,
        lpv_ant: undefined,
        lpv_inf: undefined,
      },
      practiceColors: ['#FEB3B3', '#EB1700', '#FFDF37', '#0C8AFF'],
      aifvData: {
        aifv1: 0,
        aifv2: 0,
        aifv3: 0,
        aifv4: 0,
        aifv5: 0,
        aifv6: 0
      },
      aifvFileData: [],
      isNone: false,
      imageList: [],
      defaultTime: new Date().getTime(),
      pathToFrom: {},
      isFeedBack: false,
      feedModel: '',
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    practiceMultiCode() {
      return this.userInfo.multiCode
    },
    getImage() {
      return (image) => {
        if (image.pictureMaterial && image.pictureMaterial.url) {
          return image.pictureMaterial.url
        } else if (image.pictureUrl) {
          return image.pictureUrl
        } else {
          return ''
        }
      }
    },
  },
  watch: {
    showTips(val) {
      if (val) {
        this.lockBodyScroll()
      } else {
        this.unlockBodyScroll()
      }
    },
    aifvData: {
      deep: true,
      handler(val) {
        // 当数据更新且在 report tab 时，延迟绘制 canvas
        if (val && this.activeTab === 'report') {
          setTimeout(() => {
            this.handleCanvas()
          }, 500)
        }
      }
    },
    activeTab(val) {
      // 切换到 report tab 时，如果数据已准备好则绘制
      if (val === 'report' && this.aifvAllData && Object.keys(this.aifvAllData).length > 0) {
        setTimeout(() => {
          this.handleCanvas()
        }, 500)
      }
    }
  },
  mounted() {
    this.stopReportPolling()
    // 从 URL 参数恢复 tab 状态
    const {tab} = this.$route.query
    if (tab === 'report') {
      this.activeTab = 'report'
      this.startReportPolling()
    }
    this.pathToFrom = {
      to: this.$route,
      from: this.$route
    }
    if (this.hasKdSimulatorAccess()) {
      this.showPermissionDialog()
      return
    }
    this.getApplyStatus()
    const {entrance} = this.$route.query
    this.cDialog.confirm = () => {
      if (entrance === '20' || entrance === '21') {
        this.$router.replace('/home')
      } else {
        this.$router.back()
      }
    }
    getShareInfo({
      title: 'iEP-虚拟模拟器',
      titleTimeLine: 'iEP-虚拟模拟器',
      desc: '随时随地,尽在“掌”控',
      link: window.location.href,
      linkTimeLine: window.location.href,
      images: `https://iep.jjmc.cn/bw/file/material/image/1930521902176321636.png`
    })
    this.loadPracticeReportData()
    this.loadPracticeReportFiles()
    // 获取轮播图
    this.getBannerList()
  },
  beforeDestroy() {
    this.stopReportPolling()
    this.unlockBodyScroll()
  },
  methods: {
    async handleClick(item) {
      if (!item.linkUrl) return
      const {linkUrl} = item
      const hasKeyword = (keyword) => linkUrl.includes(keyword)

      if (hasKeyword('articleDetails') || hasKeyword('dccDetail') || hasKeyword('topicDetail')) {
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}${linkUrl}`)
        this.$router.push({path: linkUrl})
        return
      }

      if (hasKeyword('courserDetails')) {
        window.sessionStorage.setItem('entrance', '105')
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}${linkUrl}`)
        const urlParamsStr = linkUrl.split('?')[1] || ''
        const urlParams = qs.parse(urlParamsStr)

        const query = {
          entrance: urlParams.entrance || '',
          channel: urlParams.channel || '',
        }

        // 添加 courseId 参数
        if (urlParams.courseId) query.courseId = urlParams.courseId

        // 判断是否为 SCORM 课程
        const courseId = urlParams.courseId || ''
        let path = '/courserDetails'
        try {
          const {data} = await isScorm(courseId)
          if (data) path = '/scormCourseDetail'
        } catch (e) {
          console.error('isScorm 调用失败:', e)
        }

        this.$router.push({path, query})
        return
      }

      if (hasKeyword('database')) {
        this.$router.push({path: linkUrl})
        return
      }

      if (hasKeyword('kdSimulator')) {
        const {veevaStatus, isDueDate} = this.userIdentity
        if (veevaStatus === '待验证' && isDueDate) {
          this.$toast('敬请期待')
          return
        }
      }

      if (item.linkUrl.indexOf('casesharing') > -1) {
        let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(
          `xxbiep${this.userInfo.iepOpenId}`
        )}`
        let url = `${item.linkUrl}${openidBindli}`
        localStorage.setItem('functionUrl', item.linkUrl)
        setTimeout(() => {
          traceClickURL()
        })
        window.location.href = url
        return
      }

      window.location.href = linkUrl
    },
    openTips() {
      // this.showTips = true
      this.cDialog.visible = true
      this.cDialog.title = '提示'
      this.cDialog.content = '由于目前手柄申请火爆，申请目前暂停，我们将于后期再次开启报名窗口，具体时间将另行通知。'
      this.cDialog.confirm = () => {
        this.cDialog.visible = false
      }
    },
    closeTips() {
      this.applyReason = ''
      this.showTips = false
    },
    // 获取轮播图
    async getBannerList() {
      const res = await getLibrayBannerByModuleApi('SIMULATOR')
      if (res) {
        if (res.code === 0 && res.data) {
          // 只需要state === '1'的数据
          this.imageList = res.data.list.filter(item => item.state === '1')
        }
      }
    },
    lockBodyScroll() {
      if (typeof document === 'undefined') return
      this.bodyStyleCache.overflow = document.body.style.overflow
      this.bodyStyleCache.touchAction = document.body.style.touchAction
      document.body.style.overflow = 'hidden'
      document.body.style.touchAction = 'none'
    },
    unlockBodyScroll() {
      if (typeof document === 'undefined') return
      document.body.style.overflow = this.bodyStyleCache.overflow || ''
      document.body.style.touchAction = this.bodyStyleCache.touchAction || ''
    },
    hasKdSimulatorAccess() {
      return this.userIdentity.veevaStatus === '待验证' && this.userIdentity.isDueDate
    },
    showPermissionDialog() {
      this.cDialog.visible = true
      this.cDialog.title = '提示'
      this.cDialog.content = '敬请期待!'
      this.cDialog.confirm = () => {
        this.cDialog.visible = false
        this.$router.replace('/home')
      }
      this.cDialog.cancel = this.cDialog.confirm
      this.cDialog.close = this.cDialog.confirm
    },
    setActiveTab(tab) {
      if (tab === 'overview') {
        this.stopReportPolling()
      }
      if (this.activeTab === tab) return
      this.activeTab = tab
      // 修改 URL 参数
      this.$router.replace({
        query: {...this.$route.query, tab}
      })
      if (this.activeTab === 'report') {
        this.startReportPolling()
      }
    },
    async startReportPolling() {
      sessionStorage.setItem('pollingOver', 'false')
      this.defaultTime = new Date().getTime()
      if (!this.pathToFrom.to) {
        this.pathToFrom = {
          to: this.$route,
          from: this.$route
        }
      }
      try {
        await trackPageView(this.pathToFrom.to, this.pathToFrom.from || this.pathToFrom.to, this.defaultTime)
      } catch (error) {
        // ignore tracking errors
      }
    },
    stopReportPolling() {
      sessionStorage.setItem('pollingOver', 'true')
      sessionStorage.removeItem('journeyPageViewId')
      clearTimeout(timeoutPolling)
    },
    // 提交申请
    applyForController: debounce(async function () {
      if (!this.applyReason) {
        Toast('请输入申请理由')
        return
      }
      postRemind(
        {
          'readType': 'simulatorControllerApplication',
          'readTypeName': '模拟器手柄申请',
          'iepUserId': this.userInfo.id,
          'applyReason': this.applyReason
        }
      ).then(() => {
        Toast('提交成功')
        this.status = true
        this.closeTips()
      })
    }, 300),
    async loadPracticeReportData() {
      if (!this.practiceMultiCode) return
      const params = {
        multiCode: this.practiceMultiCode,
      }
      try {
        const res = await getSimulatorOnePage(params)
        if (res.code !== 0 || !res.data || !res.data.multicode) {
          return
        }
        this.aifvAllData = res && res.data ? {...res.data} : {}
        // 一次性设置雷达图数据，避免多次触发 watch
        this.aifvData = {
          aifv1: res.data.mean_gap || 0,
          aifv2: res.data.mean_bp_stack || 0,
          aifv3: res.data.mean_time || 0,
          aifv4: res.data.mean_fot || 0,
          aifv5: res.data.mean_rf || 0,
          aifv6: res.data.mean_effectivetimerate || 0
        }
        // 不在这里调用 handleCanvas，由 watch 处理
      } catch (error) {
        this.aifvAllData = {}
      }
    },
    async loadPracticeReportFiles() {
      if (!this.practiceMultiCode) {
        this.isNone = true
        return
      }
      const params = {
        multiCode: this.practiceMultiCode,
        pageSize: 500,
        caseType: 1,
      }
      try {
        const res = await getAIFVFileList(params)
        if (res && res.data && res.data.list && res.data.list.length > 0) {
          this.aifvFileData = JSON.parse(JSON.stringify(res.data.list))
          this.aifvFileData.forEach(item => {
            item.createTime = this.$moment(parseInt(item.createTime)).format('YYYY-MM-DD')
            item.operationTime = this.$moment(parseInt(item.operationTime)).format('YYYY-MM-DD')
            item.updateTime = this.$moment(parseInt(item.updateTime)).format('YYYY-MM-DD')
          })
        } else {
          this.isNone = true
        }
      } catch (error) {
        this.isNone = true
      }
    },
    handleJumpPDF(item) {
      updateIsRead({
        operationId: item.id
      }).then(() => {
        this.$router.push({
          path: '/pdfView',
          query: {
            code: item.fileId,
            id: item.id
          }
        })
      })
    },
    handleCanvas() {
      const canvas = this.$refs.practiceCanvas
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      canvas.width = canvas.clientWidth
      canvas.height = canvas.clientHeight
      const centerXLeft = canvas.width / 4
      const centerXRight = (canvas.width * 3) / 4
      const centerY = canvas.height / 2
      const outerRadiusX = canvas.width / 7.4
      const outerRadiusY = canvas.width / 3.4
      const dotRadius = canvas.width / 40

      const drawCircleAndDots = (centerX, offsetAngle, colors) => {
        const numDots = 36
        const angleStep = (Math.PI * 2) / numDots
        // Draw the ellipse
        ctx.beginPath()
        ctx.ellipse(centerX, centerY, outerRadiusX, outerRadiusY, 0, 0, Math.PI * 2)

        // Draw the dots
        for (let i = 0; i < numDots; i++) {
          const angle = offsetAngle + i * angleStep
          const x = centerX + outerRadiusX * Math.cos(angle)
          const y = centerY + outerRadiusY * Math.sin(angle)
          ctx.beginPath()
          ctx.arc(x, y, dotRadius, 0, Math.PI * 2)

          // Determine the color based on the angle
          const normalizedAngle = (angle + Math.PI) % (Math.PI * 2)
          let quadrant
          if (normalizedAngle >= 0 && normalizedAngle < Math.PI * 0.2) {
            quadrant = 0
          } else if (normalizedAngle >= Math.PI * 0.2 && normalizedAngle < Math.PI * 0.8) {
            quadrant = 1
          } else if (normalizedAngle >= Math.PI * 0.8 && normalizedAngle < Math.PI * 1.2) {
            quadrant = 2
          } else if (normalizedAngle >= Math.PI * 1.2 && normalizedAngle < Math.PI * 1.8) {
            quadrant = 3
          } else {
            quadrant = 0
          }
          ctx.fillStyle = colors[quadrant] ? colors[quadrant] : '#DFE0E3'
          ctx.fill()
        }
        ctx.beginPath()
        ctx.moveTo(centerX - outerRadiusY + canvas.width / 14, centerY - outerRadiusY)
        ctx.lineTo(centerX + outerRadiusY - canvas.width / 14, centerY + outerRadiusY)
        ctx.moveTo(centerX + outerRadiusY - canvas.width / 14, centerY - outerRadiusY)
        ctx.lineTo(centerX - outerRadiusY + canvas.width / 14, centerY + outerRadiusY)
        ctx.strokeStyle = '#EB1700'
        ctx.stroke()
      }

      // Define colors for each quadrant
      const quadrantColors = [this.practiceColors[this.aifvAllData.rpv_ant], this.practiceColors[this.aifvAllData.rpv_rf], this.practiceColors[this.aifvAllData.rpv_pst], this.practiceColors[this.aifvAllData.rpv_inf]]
      const quadrantColors2 = [this.practiceColors[this.aifvAllData.lpv_pst], this.practiceColors[this.aifvAllData.lpv_rf], this.practiceColors[this.aifvAllData.lpv_ant], this.practiceColors[this.aifvAllData.lpv_inf]]

      // Draw left circle with different colored dots and diagonal cross lines
      drawCircleAndDots(centerXLeft, 0, quadrantColors)

      // Draw right circle with different colored dots and diagonal cross lines
      drawCircleAndDots(centerXRight, Math.PI, quadrantColors2)
    },
    // 查询状态
    async getApplyStatus() {
      let res = await getRemindBool({userId: this.userInfo.id, readType: 'simulatorControllerApplication'})
      if (res.code === 0) {
        this.status = res.data
      }
    },
    toCourses() {
      localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/database?courseCategoryIdFirst=1935545825602424833&courseCategoryIdSecond=1935545953646137345&courseCategoryIdThird=1982984202322636801`)
      this.$router.push({
        path: '/database?courseCategoryIdFirst=1935545825602424833&courseCategoryIdSecond=1935545953646137345&courseCategoryIdThird=1982984202322636801'
      })
    },
    handleFeedBack() {
      if (!this.feedModel) {
        this.$toast('请先输入内容再提交！')
        return
      }
      let params = {
        type: 7,
        baseId: '',
        baseTitle: '模拟器下载页反馈',
        content: this.feedModel,
        state: 2,
        userName: this.userInfo.realName,
        userId: this.userInfo.id,
        role: this.userInfo.roles[0],
        phone: this.userInfo.phone,
        email: this.userInfo.email,
        openId: this.userInfo.iepOpenId
      }
      sendFeedback(params).then(res => {
        if (res.code === 0) {
          this.feedModel = ''
          this.isFeedBack = false
          this.$toast('反馈成功')
        } else {
          this.$toast(res.msg)
        }
      })
    },
    handleCancelFeedback() {
      this.feedModel = ''
      this.isFeedBack = false
    }
  },

}
</script>

<style scoped lang="less">
.apply-container {
  position: relative;
}

.container {
  background: #F0F1F6;
  height: 100vh;
  overflow: hidden;
}

.content-wrapper {
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.apply-entry-container {
  position: absolute;
  top: 0;
  padding: 0 22px;
  width: calc(100% - 44px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  .apply-text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #D2AB68;
    line-height: 16px;
    font-style: normal;
    text-transform: none;
    width: 59.1%;

    .text {
      text-align: right;
      float: left;
    }
  }

  .apply-entry {
    cursor: pointer;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 15px;
    width: 37%;
    height: 40px;
    background: #FE0000;
    text-align: center;
    color: #F7F7F7;
    line-height: 40px;
    border-radius: 40px;
  }
}

.container {
  img {
    display: block;
  }
}

.tips-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.tips-dialog {
  width: 320px;
  border-radius: 8px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  text-align: center;
  background: #FFFBF9;

}

.header {
  display: flex;
  justify-content: center;
  padding: 15px 24px 0;
  position: relative;
  background: url("../../assets/images/dialogHeader.png") center center / 100% 100%;
}

.dialog-close {
  position: absolute;
  top: 18px;
  right: 18px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  background: url("../../assets/images/questionBank/no-passed-close-btn.png") center center / 100% 100%;
}

.dialog-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #000000;
}

.dialog-content {
  margin: 0;
  font-size: 15px;
  color: #000000;
  padding: 12px 24px 20px;
}

.dialog-item {
  text-align: left;

  .dialog-item-label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.8);
    margin-bottom: 9px;
    //  校验必填项
    &::before {
      content: '*';
      color: #eb1800;
    }
  }
}

.tips {
  margin-top: 10px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #EB1700;
}

.dialog-confirm {
  width: 130px;
  height: 42px;
  line-height: 42px;
  border: none;
  border-radius: 42px;
  background: #eb1800;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  margin: 15px auto 0;
  display: block;
}

.van-cell {
  border-radius: 8px;
  border: 1px solid #F1F1F1;
  //height: 96px;
}

.tab-container {
  display: flex;
  justify-content: space-between;
  padding: 10px 12px 0;
  gap: 12px;

  .tab-item {
    background: #f9f8f6 center center / 100% 100% no-repeat;
    width: 172px;
    height: 130px;
    border-radius: 8px;
    overflow: hidden;
  }

  .overview-tab {
    background-image: url("../../assets/images/kdSimulator/overview.png");

    &.active {
      background-image: url("../../assets/images/kdSimulator/overview_active.png");
    }
  }

  .report-tab {
    background-image: url("../../assets/images/kdSimulator/report.png");

    &.active {
      background-image: url("../../assets/images/kdSimulator/report_active.png");
    }
  }
}

.tab-panel {
  padding: 12px 0 0;
  box-sizing: border-box;
}

.tab-panel_overview {
  margin: 12px 12px 0;
  padding: 0 0 18px 0;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}

.practice-report {
  background-color: #F0F1F6;

  .aifv-cons {
    padding: 0 12px 12px;
    box-sizing: border-box;
    position: relative;
    width: 375px;
    overflow-x: hidden;

    .top-txt {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 600;
      font-size: 16px;
      color: #000000;
      padding: 16px;
      box-sizing: border-box;
    }

    .aifv-top1 {
      background: #fff;
      border: 1px solid #FFFFFF;
      border-radius: 8px 8px 0 0;

      .top-txt {
        border-bottom: 1px solid #FFFFFF;
        padding-left: 22px;
        padding-top: 15px;
        font-size: 18px;
        color: #FF5A0B;
        font-weight: 600;
        line-height: 26px;
        position: relative;
        box-sizing: border-box;
      }

      .canvas-btm {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        position: relative;
        top: -12px;

        .btm-txt {
          display: flex;
          margin-bottom: 10px;
          width: 100%;
          padding-left: 20px;
          box-sizing: border-box;

          .label-block {
            width: 24px;
            min-width: 24px;
            height: 15px;
            border-radius: 4px;
            margin-right: 4px;

            &.label-block1 {
              background-color: #EB1700;
            }

            &.label-block2 {
              background-color: #0C8AFF;
            }

            &.label-block3 {
              background-color: #FEB3B3;
            }

            &.label-block4 {
              background-color: #FFDF37;
            }
          }

          .label-txt {
            font-size: 14px;
            color: #5B5F6A;
            font-family: Inter, Inter;
            line-height: 16px;
          }
        }
      }

      .canvas-div {
        position: relative;

        .canvas {
          position: relative;
          width: 280px;
          height: 280px;
          left: 28px;
        }

        .info-flex {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: absolute;

          &.info-top {
            top: 20px;
            left: 28px;
            width: 280px;

            .txt-info {
              font-size: 14px;
            }
          }

          &.info-bottom {
            top: 234px;
            left: 28px;
            width: 280px;

            .txt-info {
              font-size: 14px;
            }
          }

          &.info-midd {
            width: 326px;
            top: 130px;
            left: 6px;
          }

          .txt-info {
            font-size: 12px;
            color: #6A7481;
            font-family: Inter, Inter;

            &.txt1 {
              flex: 1;
              text-align: center;
            }
          }
        }

        .canvas-con {
          position: absolute;
          top: 82px;

          &.canvas-con-left {
            left: 78px;
          }

          &.canvas-con-right {
            right: 92px;
          }

          .arc-txt {
            width: 39px;
            height: 39px;
            border: 2px solid #EB1700;
            border-radius: 50%;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #EB1700;
            box-shadow: 0px 0px 16px 0px rgba(255, 91, 12, 0.25);
            background-color: #fff;
            margin-bottom: 38px;
            box-sizing: border-box;
          }
        }
      }
    }

    .aifv-top2 {
      border-top: 1px solid #E0E6F7;
      background-color: #fff;
    }

    .aifv-top3 {
      border-top: 1px solid #E0E6F7;
      background-color: #fff;

      .list-table {
        background-color: #fff;
        width: 100%;
        padding: 0 8px;
        padding-bottom: 10px;
        box-sizing: border-box;

        .div-list-block {
          max-height: 160px;
          overflow-y: auto;
        }

        .table-tr {
          display: flex;
          align-items: center;
          height: 32px;
          padding: 0 10px;
          box-sizing: border-box;
          margin-bottom: 12px;
          justify-content: space-between;

          &.th {
            background-color: #fff;
            margin-bottom: 0;
          }

          &.tr {
            height: 48px;
            line-height: 14px;
            margin-bottom: 16px;
            background-color: #F5F7FC;
            margin-bottom: 6px;
            border-radius: 8px;
          }

          .table-td {
            font-size: 14px;
            color: #2b2b2b;
            font-weight: 400;
            width: 25%;

            &.table-one {
              width: 50px;
            }

            &.table-two {
              width: 95px;
            }

            &.table-three {
              width: 105px;
            }

            &.table-four {
              flex: 1;
              text-align: center;
            }

            &.table-th {
              font-size: 14px;
              color: #6A7481;
            }
          }
        }
      }

      .empty-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 20px;
        padding-bottom: 20px;

        .empty-img {
          width: 185px;
          display: block;
          margin-bottom: 4px;
        }

        .empty-txt {
          font-size: 12px;
          color: #949ba5;
          text-align: center;
        }
      }
    }
  }
}

.banner_box {
  padding: 6px 6px;
  background: #fff;
}

.banner {
  width: 100%;

  img {
    width: 100%;
    border-radius: 4px;
    height: auto;
    display: block;
  }

  /deep/ .van-swipe__track {
    width: 100% !important;
    border-radius: 12px;
  }

  /deep/ .van-swipe__indicator {
    width: 30px;
    height: 3px;
    border-radius: 1px;
    opacity: 0.6;
  }

  /deep/ .van-swipe__indicator--active {
    opacity: 1;
  }
}

.courses_btn {
  width: 204px;
  height: 40px;
  background: linear-gradient(180deg, #FFC987 0%, #FE0000 100%);
  border-radius: 40px;
  line-height: 40px;
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 15px;
  color: #F7F7F7;
  margin: 16px auto 0;
}

.feedback {
  width: 52px;
  height: 52px;
  position: fixed;
  right: 12px;
  bottom: 52px;
  z-index: 999;
}

/deep/ .van-overlay {
  z-index: 9999;

  .wrap {
    width: 320px;
    border-radius: 10px;
    background: #fff;
    padding: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;

    .wrap-txt {
      font-size: 17px;
      font-weight: 600;
      color: #000000;
      text-align: center;
      font-family: Source Han Sans CN, Source Han Sans CN;
      line-height: 20px;
      width: 100%;
      margin-bottom: 10px;
    }

    .wrap-con {
      width: 288px;
      height: 120px;
      margin-left: 50%;
      transform: translateX(-50%);
      color: #666;
      font-size: 16px;
      overflow: hidden;
      background: #F9F8F7;
      border-radius: 8px;
      margin-bottom: 10px;

      .van-cell {
        background: rgba(0, 0, 0, 0.02);
        height: 120px;
      }

      .van-field__value {
        overflow-y: auto;

        .van-field__control {
          height: 80px !important;
          line-height: 22px;
          font-size: 16px;
          color: #333;

          &::placeholder {
            color: rgba(0, 0, 0, 0.40);
          }
        }
      }
    }

    .warp-btn {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 8px;
      box-sizing: border-box;

      .btn {
        text-align: center;
        font-size: 17px;
        font-weight: 500;
        border-radius: 30pc;
        height: 42px;
        line-height: 42px;

        &.btn1 {
          color: #81766F;
          background: #F1EFED;
        }

        &.btn2 {
          background: #EB1700;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/kdSimulator/poster.vue